import { useState, useEffect, useRef } from 'react';

export default function useCurrentPosition({ enabled = true, highAccuracy = true } = {}) {
  const [position, setPosition] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const watchId = useRef(null);

  useEffect(() => {
    if (!enabled || !navigator.geolocation) {
      setLoading(false);
      setError(!navigator.geolocation ? 'Geolocalización no soportada' : null);
      return;
    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          heading: pos.coords.heading,
          speed: pos.coords.speed,
          accuracy: pos.coords.accuracy,
        });
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
      { enableHighAccuracy: highAccuracy, timeout: 10000, maximumAge: 5000 }
    );

    watchId.current = navigator.geolocation.watchPosition(
      (pos) => {
        setPosition({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          heading: pos.coords.heading,
          speed: pos.coords.speed,
          accuracy: pos.coords.accuracy,
        });
        setError(null);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
      },
      { enableHighAccuracy: highAccuracy, timeout: 10000, maximumAge: 3000 }
    );

    return () => {
      if (watchId.current) {
        navigator.geolocation.clearWatch(watchId.current);
      }
    };
  }, [enabled, highAccuracy]);

  return { position, error, loading };
}
